import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const RefreshIcon = React.memo(function RefreshIcon(props: TRefreshIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Refresh" {...props}>
            <path
                d="M6.98213 14.9455C6.71546 14.4848 6.51546 14.0121 6.38213 13.5273C6.2488 13.0424 6.18213 12.5455 6.18213 12.0364C6.18213 10.4121 6.74577 9.0303 7.87304 7.89091C9.00031 6.75152 10.3761 6.18182 12.0003 6.18182H12.1276L10.9639 5.01818L11.9821 4L14.8912 6.90909L11.9821 9.81818L10.9639 8.8L12.1276 7.63636H12.0003C10.7882 7.63636 9.75789 8.06364 8.9094 8.91818C8.06092 9.77273 7.63667 10.8121 7.63667 12.0364C7.63667 12.3515 7.67304 12.6606 7.74577 12.9636C7.81849 13.2667 7.92758 13.5636 8.07304 13.8545L6.98213 14.9455ZM12.0185 20L9.1094 17.0909L12.0185 14.1818L13.0367 15.2L11.873 16.3636H12.0003C13.2124 16.3636 14.2427 15.9364 15.0912 15.0818C15.9397 14.2273 16.3639 13.1879 16.3639 11.9636C16.3639 11.6485 16.3276 11.3394 16.2549 11.0364C16.1821 10.7333 16.073 10.4364 15.9276 10.1455L17.0185 9.05455C17.2852 9.51515 17.4852 9.98788 17.6185 10.4727C17.7518 10.9576 17.8185 11.4545 17.8185 11.9636C17.8185 13.5879 17.2549 14.9697 16.1276 16.1091C15.0003 17.2485 13.6246 17.8182 12.0003 17.8182H11.873L13.0367 18.9818L12.0185 20Z"
                fill="currentColor"
            />
        </IconBase>
    );
});

export default RefreshIcon;

// #region Types

export type TRefreshIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <RefreshIcon /> : { ...IconBaseExample, render: RefreshIcon };

// #endregion
